import { Trans } from '@lingui/macro';
import * as React from 'react';
import { newsLetterSubmitErrorState, resetNewsLetterStates } from '../../state';
import { NewsLetterErrorContainer, NewsLetterErrorIcon, NewsLetterErrorReturnButton } from './components';

export const NewsLetterSubmitError = () => {
  React.useEffect(() => {
    let timeout: NodeJS.Timeout | undefined;
    if (timeout != null) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      resetNewsLetterStates();
      newsLetterSubmitErrorState.set(null);
    }, 5000);
    return () => {
      if (timeout != null) {
        resetNewsLetterStates();
        newsLetterSubmitErrorState.set(null);
        clearTimeout(timeout);
      }
    };
  }, []);
  return (
    <NewsLetterErrorContainer>
      <NewsLetterErrorIcon />
      <Trans>
        Une erreur s'est produite, veuillez réessayer plus tard
      </Trans>
      <NewsLetterErrorReturnButton />
    </NewsLetterErrorContainer>
  );
};
